"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
AnalyticsService.$inject = ['$rootScope', '$location'];
function AnalyticsService($rootScope, $location) {
    var service = {};
    var data = {};
    if (typeof gtag === 'function') {
        gtag('config', 'UA-12245525-27', {
            'custom_map': { 'metric1': 'user_name' }
        });
    }
    service.pageView = function (item) {
        if (typeof gtag === 'function') {
            gtag('config', 'UA-12245525-27', { 'page_path': $location.url() });
        }
    };
    service.viewItem = function (item) {
        if (typeof gtag === 'function') {
            data.user_name = $rootScope.currentUser.full_name;
            gtag('event', 'view_item', { "items": [_.merge(data, item)] });
        }
    };
    service.addToCart = function (item) {
        if (typeof gtag === 'function') {
            data.user_name = $rootScope.currentUser.full_name;
            gtag('event', 'add_to_cart', { "items": [_.merge(data, item)] });
        }
    };
    service.removeFromCart = function (item) {
        if (typeof gtag === 'function') {
            data.user_name = $rootScope.currentUser.full_name;
            gtag('event', 'remove_from_cart', { "items": [_.merge(data, item)] });
        }
    };
    service.purchase = function (item) {
        if (typeof gtag === 'function') {
            data.user_name = $rootScope.currentUser.full_name;
            gtag('event', 'purchase', _.merge(data, item));
        }
    };
    return service;
}
exports.default = angular.module('rinca.core.analytics', [])
    .service('_analytics', AnalyticsService);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/services/analytics.js
// module id = 296
// module chunks = 0